import React from 'react';
import UserHeader from './UserHeader';

const Index = () => {
  return (
    <div>
      <UserHeader />
    </div>
  );
};

export default Index;
